export default __webpack_public_path__ + "static/media/x-circle-light.ae16a6de.svg";